// extracted by mini-css-extract-plugin
module.exports = {"filter":"LXbMw9127DRAMuVgmMAxD"};